import React, { useState } from "react"

const SUGGESTIONS = [
  "Is he a fit for a senior platform / DevOps role?",
  "Summarize his agentic-AI and LLM work.",
  "How deep is his AWS & Kubernetes experience?",
  "What have clients said about working with him?",
]

const PROFILE_HINT =
  "You are helping evaluate Nishant Tiwari. His full machine-readable profile is at " +
  "https://nishanttiwari.com/api/profile.json (discovery doc: " +
  "https://nishanttiwari.com/.well-known/ai-profile.json ; smaller sections at " +
  "https://nishanttiwari.com/api/profile/<section>.json). Read it, then answer factually " +
  "and concretely, citing specific projects, experience, or skills. If asked about fit, give a " +
  "clear verdict with reasons."

const buildPrompt = q =>
  `${PROFILE_HINT}\n\nQuestion: ${
    (q || "").trim() ||
    "Give me a 5-bullet summary of whether Nishant is a strong hire, and why."
  }`

const ResumeChat = () => {
  const [q, setQ] = useState("")
  const [copied, setCopied] = useState(false)

  const ask = (engine, question) => {
    const text = buildPrompt(question != null ? question : q)
    const enc = encodeURIComponent(text)
    if (engine === "claude") {
      window.open(`https://claude.ai/new?q=${enc}`, "_blank", "noopener,noreferrer")
    } else if (engine === "copy") {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => {
          setCopied(true)
          setTimeout(() => setCopied(false), 2000)
        })
      }
    } else {
      window.open(`https://chatgpt.com/?q=${enc}`, "_blank", "noopener,noreferrer")
    }
  }

  return (
    <section className="section resume-chat">
      <div className="section-center">
        <div className="resume-chat-card">
          <div className="resume-chat-head">
            <span className="resume-chat-badge">
              <span className="resume-chat-dot"></span>ask my profile
            </span>
            <h2>Talk to my résumé</h2>
            <p>
              Ask anything about my experience — your own AI answers it from my full profile.
              No sign-up, no install, works in any AI.
            </p>
          </div>

          <div className="resume-chat-suggest">
            {SUGGESTIONS.map((s, i) => (
              <button
                key={i}
                type="button"
                className="resume-chat-chip"
                onClick={() => ask("chatgpt", s)}
              >
                {s}
              </button>
            ))}
          </div>

          <form
            className="resume-chat-input"
            onSubmit={e => {
              e.preventDefault()
              ask("chatgpt")
            }}
          >
            <input
              type="text"
              value={q}
              onChange={e => setQ(e.target.value)}
              placeholder="Ask about my experience, projects, stack, availability…"
              aria-label="Ask a question about Nishant"
            />
            <button type="submit" className="resume-chat-send">
              Ask <span aria-hidden="true">→</span>
            </button>
          </form>

          <div className="resume-chat-engines">
            <span>Opens in</span>
            <button type="button" onClick={() => ask("chatgpt")}>
              ChatGPT
            </button>
            <button type="button" onClick={() => ask("claude")}>
              Claude
            </button>
            <button type="button" onClick={() => ask("copy")}>
              {copied ? "Copied ✓" : "Copy prompt"}
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ResumeChat
